import React from "react";
import ReactLoading from "react-loading";

const LoadingComponent = () => {
  return (
    <div className="flex justify-center items-center py-8">
      <ReactLoading
        type="spin"
        color="rgb(var(--ui-primary))"
        className="ux-fade-in h-14 w-14 mx-auto"
      />
    </div>
  );
};

export default LoadingComponent;
